var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([_vm.maskStyle, _vm.zoomStyle])

  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      $event.stopPropagation()
      $event.preventDefault()
      return (function () {})($event)
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }